export default "__VITE_ASSET__CvsYKmfD__"